export default {
  getLoading: (state) => state.isLoading,

  getRoles: (state) => {
    const roles = [...state.roles];
    return roles;
  },
};
